export default __webpack_public_path__ + "static/subMenuHelp-2c1190d9d3762fe1a5a9f93a10313ce0.svg";